import React, { FC, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  makeStyles,
  Menu,
  Box,
  Button,
  Slide,
  Dialog
} from '@material-ui/core';

import { ReactComponent as ProfileDefault } from 'src/images/profile.svg';
import { RootState, useSelector } from 'src/store';
import { AuthContext } from 'src/contexts/authContext';
import SettingsModal from 'src/components/Modal/SettingsModal';
import { TransitionProps } from '@material-ui/core/transitions';
import ChevronUp from 'src/components/Icon/ChevronUp';
import ChevronDown from 'src/components/Icon/ChevronDown';

const useStyles = makeStyles(() => ({
  profileButton: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',

    cursor: 'pointer',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 15,
    textTransform: 'none',
    background: '#ffffff'
  },
  profileBox: {
    height: 38,
    display: 'flex',
    alignItems: 'center'
  },
  profileInfo: {
    width: 135,
    display: 'flex',
    flexDirection: 'column',

    lineHeight: '120%',
    textAlign: 'left',
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'Poppins'
  },
  profileName: {
    height: 16,
    marginBottom: '0.25rem',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  profileCompany: {
    height: 15,
    fontSize: '0.75rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  menuModal: {
    width: '252px',
    marginTop: 65,
    padding: '16px',
    color: '#000000',
    borderRadius: 16,
    border: '2px solid #E8E8E8',
    boxShadow: 'none',

    position: 'relative'
  },
  menu: {
    width: '100%',
    height: 'auto',
    color: '#000',

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textDecoration: 'none',
    padding: '5px 0px',
    borderBottom: '2px solid #E8E8E8'
  },
  icon: {
    display: 'flex',
    alignItems: 'center'
  },
  dialog: {
    top: 0,
    right: 0,
    position: 'fixed',
    width: '50%',
    margin: 0,
    height: '100%',
    maxHeight: 'max-content',
    borderRadius: 0
  }
}));

const Account: FC<{ expireDate: any; exportedCount: number }> = ({
  expireDate,
  exportedCount
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  let userCompany = useSelector((state: RootState) => state.client.userCompany);
  let userName = useSelector((state: RootState) => state.client.userName);
  let userEmail = useSelector((state: RootState) => state.client.userEmail);
  let userGrade = useSelector((state: RootState) => state.client.userGrade);
  const USER_COMPANY = userCompany
    .split(' ')
    .map(str => str.replace(/^[a-z]/, char => char.toUpperCase()))
    .join(' ');
  const USER_NAME =
    userName === ''
      ? userEmail.split('@')[0]
      : userName.replace(/^[a-z]/, char => char.toUpperCase());

  const handleClickModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseModal = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button className={classes.profileButton} onClick={handleClickModal}>
        <Box className={classes.profileBox}>
          <ProfileDefault
            style={{
              width: '37px',
              height: '37px',
              margin: '0px 16px'
            }}
          />
          <Box className={classes.profileInfo}>
            <p className={classes.profileName}>{USER_NAME || 'username'}</p>
            <p className={classes.profileCompany}>
              {USER_COMPANY || 'company'}
            </p>
          </Box>
          {anchorEl ? <ChevronUp /> : <ChevronDown />}
        </Box>
      </Button>
      <AccountModal
        userInfo={{ userGrade, expireDate, exportedCount }}
        visible={{ anchorEl, handleCloseModal }}
      />
    </>
  );
};

const AccountModal = ({ userInfo, visible }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState('');
  const [hidden, setHidden] = useState('hidden');

  async function handleLogout() {
    try {
      await authContext.signOut();
      window.location.href = 'https://www.inappmessage.com';
    } catch (error) {}
  }

  const handleCustomFont = () => {
    setCurrentTab('customfont');
    setSettingsOpen(true);
    setHidden('visible');
  };
  const handleBilling = () => {
    history.push('/billing/subscription');
    setHidden('visible');
  };
  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="left" ref={ref} {...props} />;
  });

  const handleModalClose = () => {
    setSettingsOpen(false);
    setHidden('hidden');
  };

  return (
    <>
      <Menu
        id="simple-menu"
        anchorEl={visible.anchorEl}
        keepMounted
        open={Boolean(visible.anchorEl)}
        onClose={visible.handleCloseModal}
        classes={{ paper: classes.menuModal }}
      >
        <div
          style={{
            fontSize: '20px',
            fontWeight: 700,

            width: '100%'
          }}
        >
          ACCOUNT INFO
        </div>
        <Box
          style={{
            display: 'flex',
            width: '100%',
            height: 'auto',

            fontSize: '16px',
            fontWeight: 800,

            padding: '5px',

            borderRadius: '10px',
            background: ' #E8E8E8',
            margin: '16px 0px'
          }}
        >
          <div
            style={{
              width: '100%',
              height: 'auto',

              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#ffffff',
              borderRadius: '10px',
              padding: '10px',
              gap: '10px',
              fontWeight: 500,
              fontSize: '14px'
            }}
          >
            <p>PLAN: {userInfo.userGrade.toUpperCase()}</p>
            {userInfo.expireDate === 'expired' ? (
              <p>REMAIN EXPORT: {50 - userInfo.exportedCount} </p>
            ) : (
              <p>EXPIRE: {userInfo.expireDate} </p>
            )}
          </div>
        </Box>
        <Button
          onClick={handleCustomFont}
          className={classes.menu}
          style={{ marginBottom: '15px' }}
        >
          <span>Custom Font</span>
        </Button>
        <Button
          onClick={handleBilling}
          className={classes.menu}
          style={{ marginBottom: '15px' }}
        >
          <span>Billing</span>
        </Button>
        <Button className={classes.menu} onClick={handleLogout}>
          <span>Logout</span>
        </Button>
      </Menu>
      <Dialog
        classes={{ paper: classes.dialog }}
        TransitionComponent={Transition}
        open={settingsOpen}
        onBackdropClick={handleModalClose}
        maxWidth={false}
        style={{ visibility: hidden === 'hidden' ? 'hidden' : 'visible' }}
      >
        <SettingsModal handleClose={handleModalClose} currentTab={currentTab} />
      </Dialog>
    </>
  );
};

export default Account;
